module.exports = __webpack_public_path__ + "static/media/cof_results.36d1bba5.png";